import { Component, OnInit } from '@angular/core';
import { HttpClient } from '../../generic/service/http.service';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfigurationHelper } from '../../generic/helper/configuration.helper';
import { CustomDatePipe } from '../../generic/pipes/custom.date.pipe';

/**
 * Footer component which includes the footer rendered by the website.
 *
 * @author hillebrand
 */
@Component({
    selector: 'footer-menu',
    template: ` @if (!isKvkShop) {
  <footer
    class="footer"
  [innerHTML]="footerHtml"></footer>
}
@if (isKvkShop) {
  <footer class="footer kvk-footer">
    <div class="footer-disclaimer-menu">
      <div class="row">
        <div class="col-12">
          <p>
            &copy; {{ shopName }} -
            {{ currentDate | customDate: 'YYYY' }}
          </p>
        </div>
      </div>
    </div>
  </footer>
}`,
    standalone: true,
    imports: [CustomDatePipe],
})
export class FooterComponent implements OnInit {
    currentDate: Date = new Date();
    footerHtml: SafeHtml;
    shopName: string = ConfigurationHelper.getSettings().name;
    isKvkShop: boolean = ConfigurationHelper.getSettings().kvkShop;

    /**
     * HttpClient from http.service.ts isn't used because it expects json
     *
     * @param http
     */
    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer,
    ) {}

    /**
     * Initialise the footer html by getting the content/html from the Lavic website.
     * Since KVK shops don't have a Lavic website we do not retrieve the content/html.
     */
    ngOnInit() {
        if (!this.isKvkShop) {
            this.http.getText('/public/footer').subscribe(footerHtml => {
                this.footerHtml =
                    this.sanitizer.bypassSecurityTrustHtml(footerHtml);
            });
        }
    }
}
